import { StateLabel } from './StateLabel';
import { useWorkflowState, type WorkflowStateInfo } from './useWorkflowState';

/** Rótulo do estado seguido de uma linha discreta, no estilo "Veja também". */
export const StateRule = ({ info }: { info: WorkflowStateInfo }) => (
  <div className="mpf-state-rule">
    <StateLabel info={info} />
    <span
      aria-hidden="true"
      className="mpf-state-rule__line"
      style={{ backgroundColor: info.color }}
    />
  </div>
);

/**
 * Mesma faixa de estado da view (divisor da notícia), agora no editor: cor e
 * rótulo do estado de publicação atual.
 */
export const EditorStateLine = ({ reviewState }: { reviewState?: string }) => {
  const info = useWorkflowState(reviewState);
  return info ? <StateRule info={info} /> : null;
};

export default EditorStateLine;
